import createModel from 'utils/model'
import {personalTags, corpTags, tag} from 'crm/services/tags'

export default createModel({
    namespace: 'crm_tags',
    state: {},

    subscriptions: {},

    effects: {
        *personalTags({payload}, {call}) {
            return yield call(personalTags, payload)
        },
        *corpTags({payload}, {call}) {
            return yield call(corpTags, payload)
        },
        *tag({payload}, {call}) {
            return yield call(tag, payload)
        },
    },

    reducers: {},
})
